interface CharacterCountProps {
    value: string;
    maxLength: number;
}

export const CharacterCount = ({ value, maxLength }: CharacterCountProps) => {
    const currentLength = (value || '').length;
    const isAtLimit = currentLength >= maxLength;

    return (
        <p className={`text-xs ${isAtLimit ? 'font-semibold text-red-500' : 'text-gray-400'}`}>
            {currentLength}/{maxLength}
        </p>
    );
};
